import { Textures as ParkTextures } from '@Renderer/texturepacks/Park.js';
import { Textures as ParkCourseTextures } from '@Renderer/texturepacks/ParkCourse.js';
import { Textures as ParkPreviewTextures } from '@Renderer/texturepacks/ParkPreview.js';

import { Textures as ForestTextures } from '@Renderer/texturepacks/Forest.js';
import { Textures as ForestCourseTextures } from '@Renderer/texturepacks/ForestCourse.js';
import { Textures as ForestPreviewTextures } from '@Renderer/texturepacks/ForestPreview.js';

import { Textures as LinksTextures } from '@Renderer/texturepacks/Links.js';
import { Textures as LinksCourseTextures } from '@Renderer/texturepacks/LinksCourse.js';
import { Textures as LinksPreviewTextures } from '@Renderer/texturepacks/LinksPreview.js';

export const Packs = {
	park: ParkTextures,
	parkCourse: ParkCourseTextures,
	parkPreview: ParkPreviewTextures,
	forest: ForestTextures,
	forestCourse: ForestCourseTextures,
	forestPreview: ForestPreviewTextures,
	links: LinksTextures,
	linksCourse: LinksCourseTextures,
	linksPreview: LinksPreviewTextures
}